__webpack_require__.p = "https://hospital-roaming.waxeye.dev/";